import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import {
  Text,
  Tabs,
} from '@beef/ui-kit';

import { Icon } from 'components';
import {
  DETALIZATION_MODAL_DOWNLOAD_OPTIONS,
  DETALIZATION_MODAL_COMMON,
} from 'constants/detalization';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const downloadTabs = Object.keys(DETALIZATION_MODAL_DOWNLOAD_OPTIONS).map((key) => ({
  id: DETALIZATION_MODAL_DOWNLOAD_OPTIONS[key],
  title: DETALIZATION_MODAL_DOWNLOAD_OPTIONS[key],
  icon: <Icon name="letter" />,
}));

export const SelectReportType = ({
  isError,
  onChange,
  value,
}) => (
  <div className={cx('format-wrapper', {
    'format-wrapper--error': isError,
  })}
  >
    <Text size="size5-b">{DETALIZATION_MODAL_COMMON.FORMAT}</Text>
    <div className={cx('format-tabs-wrapper')}>
      <Tabs
        noWrap
        onChange={onChange}
        selectedTab={value === 'XLS' ? 'XLS' : value}
        tabs={downloadTabs}
        variant="secondary"
      />
    </div>
  </div>
);

SelectReportType.propTypes = {
  isError: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
};
